import Layout from '@/layout';
var activityRouter = {
  path: '/activity',
  component: Layout,
  redirect: '/activity/list',
  name: 'activity',
  meta: {
    title: '活动管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/activity/list');
    },
    name: 'List',
    meta: {
      title: '活动管理',
      icon: ''
    }
  }, {
    path: 'list/creatActivity/:id?',
    component: function component() {
      return import('@/views/activity/createActivity');
    },
    name: 'SortCreat',
    meta: {
      title: '活动添加/编辑',
      noCache: true,
      activeMenu: "/activity/list"
    },
    hidden: true
  }, {
    path: 'activityImitate',
    component: function component() {
      return import('@/views/activity/activityImitate');
    },
    name: 'ActivityImitate',
    meta: {
      title: '活动模拟数据开关',
      icon: ''
    }
  }, {
    path: 'dataList',
    component: function component() {
      return import('@/views/activity/dataList');
    },
    name: 'DataList',
    meta: {
      title: '活动数据',
      icon: ''
    }
  }]
};
export default activityRouter;